import { createSelector, createFeatureSelector } from '@ngrx/store';

import { FeedState } from './../../models/feed.model';

export const getFeedState = createFeatureSelector<FeedState>('feed');

export const getDeliveryLines = createSelector(
  getFeedState,
  (state: FeedState) => state?.deliveryLines,
);
